/* eslint-disable max-len */
export default {
  en: {
    projects: {
      new: 'New Project',
      title: 'Projects',
      my: 'My Projects',
      shared: 'Shared',
      public: 'Public',
      starred: 'Favorites',
      publicProjects: 'Public projects',
      inGitflic: 'Project {title} on the Gitflic',
      none: 'No Projects',
      updatedAt: 'Updated at {time}',
      mirror: 'mirror',
      private: 'private',
      wiki: 'wiki',
      owner: {
        isOwner: 'Owner',
        inTeam: 'In team',
        inCompany: 'In company'
      },
      leave: {
        title: 'Leave project',
        description:
          'If you quit a {title} project, you will lose the ability to work with it, as well as cloning if the project is private and uploading files to the repository.',
        controlString: {
          description: 'Please write <b>{controlString}</b> for confirmation'
        }
      },
      report: {
        title: 'Report'
      },
      star: {
        isStarred: 'Favorites',
        notStarred: 'Add in favorites'
      },
      delete: {
        title: 'Delete Project',
        description: 'Repository {title} and all associated data will be permanently deleted.',
        controlString: {
          description: 'Please write <b>{controlString}</b> for confirmation'
        }
      }
    }
  },
  ru: {
    projects: {
      new: 'Новый проект',
      title: 'Проекты',
      my: 'Мои проекты',
      shared: 'С моим участием',
      public: 'Публичные',
      starred: 'Избранные',
      publicProjects: 'Публичные проекты',
      inGitflic: 'Проект {title} на Gitflic',
      none: 'Нет проектов',
      updatedAt: 'Обновлен {time}',
      mirror: 'зеркало',
      private: 'приватный',
      wiki: 'вики',
      owner: {
        isOwner: 'Вы владелец',
        inTeam: 'В команде',
        inCompany: 'В компании'
      },
      leave: {
        title: 'Покинуть проект',
        description:
          'При выходе из проекта {title} вы потеряете возможность работать с ним, а также совершать клонирование, если проект приватный, и загрузку файлов в репозиторий.',
        controlString: {
          description: 'Пожалуйста, напишите <b>{controlString}</b> для подтверждения'
        }
      },
      report: {
        title: 'Пожаловаться на проект'
      },
      star: {
        isStarred: 'Избранное',
        notStarred: 'В избранное'
      },
      delete: {
        title: 'Удаление проекта',
        description: 'Репозиторий {title} и все связанные с ним данные будут удалены навсегда.',
        controlString: {
          description: 'Пожалуйста, напишите <b>{controlString}</b> для подтверждения'
        }
      }
    }
  }
};
